import React, { useState, useEffect } from "react";
import Layout from "../../components/Layout/Layout";
import BeatLoader from "react-spinners/BeatLoader";
import { collection, getDocs, doc, getDoc, deleteDoc } from "@firebase/firestore";
import { db } from "../../firebase/firebase-config";
import CreateCaseModal from "../../components/ui/CreateCaseModal/CreateCaseModal";
import EditCaseModal from "../../components/ui/EditCaseModal/EditCaseModal";
import { BsPersonFillAdd } from "react-icons/bs";
import { Table, Input, Select } from 'antd';
import SelectUserModal from "../../components/ui/SelectUserModal/SelectUserModal";
import { RiEditBoxFill } from 'react-icons/ri';
import { ConfirmModal } from "../../components";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { BsFillTrashFill } from 'react-icons/bs';
import { IoPersonRemoveSharp } from "react-icons/io5";
import moment from 'moment';
import UnassignCaseModal from "../../components/ui/UnassignCaseModal/UnassignCaseModal";
import { RiFolderUserFill } from "react-icons/ri";
import PatientDetailsModal from "./PatientDetailsModal/PatientDetailsModal";
import { getAllCases } from "../../services/cases";

const { Search } = Input;


const override = {
  marginTop: "20px",
};

function Index() {
  const [loading, setLoading] = useState(false);
  const [caseData, setCaseData] = useState<any[]>([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [searchText, setSearchText] = useState<string>('');
  const [filteredData, setFilteredData] = useState<any[]>(caseData);

  const [showAssignedModal, setShowAssignedModal] = useState<any>()
  const [selectedCaseCategory, setSelectedCaseCategory] = useState('');
  const [selectedCase, setSelectedCase] = useState("");
  const [selectedCaseData, setSelectedCaseData] = useState(null);
  const [docs, setDocs] = useState([]);

  const [showUnassignUserModal, setShowUnassignUserModal] = useState(false);

  const [showConfirmodal, setShowConfirmModal] = useState(false);
  const [currentActiveId, setCurrentActiveId] = useState(null);

  const [showPatientDetailsModal, setShowPatientDetailsModal] = useState(false);
  const [patientId, setPatientId] = useState(null);

  const toggleAddModal = async () => {
    setShowCreateModal(!showCreateModal);
  };

  const toggleAssignedSlideModal = () => {
    setShowAssignedModal(!showAssignedModal);
  }

  const toggleUnAssignSlideModal = () => {
    setShowUnassignUserModal(!showUnassignUserModal);
  }



  const handleContentAdded = () => {
    toggleAddModal();
  };

  const fetchData = async () => {
    setLoading(true);

    getAllCases().then((res:  any) => {
      // console.log('RESPONSE FROM API: ', res.data);
      setDocs(res.data.tempDocs);
      setCaseData(res.data.caseData);
      setLoading(false);
    })

   
  }

  

  const formatTimeStamp = (milliseconds: string, data: any) => {
    let date;
  
    if (isNaN(parseInt(milliseconds))) {
      if (
        typeof data === 'object' &&
        data !== null &&
        typeof data.toDate === 'function'
      ) {
        date = data.toDate();
      } else if (
        typeof data === 'object' &&
        data !== null &&
        data._seconds &&
        data._nanoseconds
      ) {
        const seconds = data._seconds;
        const milliseconds = seconds * 1000 + Math.floor(data._nanoseconds / 1000000);
        date = new Date(milliseconds);
      } else {
        console.error('Invalid data object');
        return '';
      }
    } else {
      date = new Date(parseInt(milliseconds));
    }
  
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
  
    return `${month}-${day}-${year}`;
  };

  const [sortedInfo, setSortedInfo] = useState<any>({});

  const handleChange = (pagination: any, filters: any, sorter: any) => {
    setSortedInfo(sorter);
  };

  useEffect(() => {

    let newData = filterData(caseData, searchText);

    const sortedData = newData.sort((a:any, b: any) => {
      const cidNumberA = parseInt(a.CID?.split('-')[1], 10);
      const cidNumberB = parseInt(b.CID?.split('-')[1], 10);
      return cidNumberB.toString().padStart(5, '0').localeCompare(cidNumberA.toString().padStart(5, '0'));
    });
    // console.log('NEW CASE DATA SORTED: $$$', sortedData);
    setFilteredData(filterData(sortedData, searchText));
  }, [caseData, searchText]);


  const filterData = (data: any[], query: string) => {
    // console.log('DATA:  ', data);
    if (!query) return data;

    return data.filter((item) =>
      Object.values(item).some((value: any) =>
        value == null? "" : value.toString().toLowerCase().includes(query.toLowerCase())
      )
    );
  };


  const handleSearch = (value: string) => {
    setSearchText(value);
  };

  let [patientSearchPhone, setPatientSearchPhone] = useState('');

  const handleSearchPatietsPhone = (value: string) => {
    if(value.length !== 9) {
      // WRONG NUMBER
      console.log('WRONG NUMBER');
      return;
    }
    let p_Phone = Number(value);

    console.log('PATIENT PHONE: ', value);
    
  };

  const clearPatientSearch = (value: string) => {
    if(value.length < 1) {
      // RESET TABLE
      console.log('RESET TABLE****');
    }
  }



  const rows: any = [
  
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'name',
      sorter: (a: any, b: any) => a?.name?.localeCompare(b.name),
    },
    {
      title: 'Label',
      dataIndex: 'label',
      key: 'label',
      sorter: (a: any, b: any) => a?.label?.localeCompare(b.label),
    },
    {
      title: 'Case Code',
      dataIndex: 'CID',
      key: 'CID',
      // sorter: (a: any, b: any) => a.CID.localeCompare(b.CID),
    },

    {
      title: 'Resolved',
      dataIndex: 'is_case_resolved',
      key: 'is_case_resolved',
      sorter: (a: any, b: any) => (a.is_case_resolved ? 1 : -1) - (b.is_case_resolved ? 1 : -1),
      render: (is_case_resolved: boolean) => (is_case_resolved ? "Resolved":"Unresolved"),
    },
    {
      title: 'Is Personal',
      dataIndex: 'isPersonal',
      key: 'isPersonal',
      sorter: (a: any, b: any) => (a?.isPersonal ? 1 : -1) - (b?.isPersonal ? 1 : -1),
      render: (isPersonal: any)=> (isPersonal == "Yes" ? "True": "False"),
    },
    {
      title: 'Assigned',
      dataIndex: 'assigned',
      key: 'assigned',
      render: (assigned: boolean)=> (assigned? "True": "False"),
      sorter: (a: any, b: any) => (a?.assigned ? 1 : -1) - (b?.assigned ? 1 : -1),
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (createdAt: any)=> (formatTimeStamp(`${createdAt}`,createdAt)),
      // sorter: (a: any, b: any) => a.createdAt.localeCompare(b.createdAt),
      // sorter: (a: any, b: any) => {
      //   const dateA = new Date(a.createdAt);
      //   const dateB = new Date(b.createdAt);
      //   return dateA.getTime() - dateB.getTime();
      // },
  
    },
    {
      title: 'Patient ID',
      dataIndex: 'patient_uid',
      key: 'patient_uid',
      // sorter: (a: any, b: any) => a.CID.localeCompare(b.CID),
    },
    {
    title: "Action",
    dataIndex: "action",
    key: "action",
    render: (_: any, record: any) => (
      <td>
        <i
          style={{ position: "relative", top: 3, cursor: "pointer" }}
          onClick={() => {
            // setSelectedModal("Slide")
            // setSelectedCase(record.name);
            // console.log("RECORD: ",record);

            setSelectedCase(record?.name)
            setSelectedCaseData(record);
            setSelectedCaseCategory(record?.category);
            toggleAssignedSlideModal();
          }}
        >
          <BsPersonFillAdd
            style={{
              backgroundColor: "#3080ED",
              padding: 5,
              borderRadius: 5,
              color: "white",
              marginRight: 15,
            }}
            size={30}
          />
        </i>

        <i
          style={{ position: "relative", top: 3, cursor: "pointer" }}
          onClick={() => {

            console.log('RECORD: ## - ',record);
            if(record?.patient_uid) {
              // SHOW PATIENT INFO MODAL
              setPatientId(record?.patient_uid);
              setShowPatientDetailsModal(true);
            }
            // setSelectedCase(record?.name)
            // setSelectedCaseData(record);
            // setSelectedCaseCategory(record?.category);
            // toggleAssignedSlideModal();
          }}
        >
          <RiFolderUserFill
            style={{
              backgroundColor: "#4F5052",
              padding: 5,
              borderRadius: 5,
              color: "white",
              marginRight: 15,
            }}
            size={30}
          />
        </i>

       {record.assigned && <i
          style={{ position: "relative", top: 3, cursor: "pointer" }}
          onClick={() => {
            //TOGGLE UNASSIGN MODAL
            //SHOW ASSIGNED USER LIST FOR  USER TO SELECT WHOM TO UNASSIGN
            
            console.log('DATA: ', record)
            setSelectedCase(record?.name)
            setSelectedCaseData(record);
            setSelectedCaseCategory(record?.category);
            toggleUnAssignSlideModal();
          }}
        >
          <IoPersonRemoveSharp
            style={{
              backgroundColor: "#4F5052",
              padding: 5,
              borderRadius: 5,
              color: "white",
              marginRight: 15,
            }}
            size={30}
          />
        </i>
        }
        <>
            {record?.category == 'Pathology' &&   <i
            style={{ position: "relative", top: 3, cursor: "pointer" }}
            onClick={() => {
              // setSelectedModal("Case")
              // setSelectedCase(record.name);
              setItemToBeEdited(record);
              toggleEditModal();
            }}
          >
            <RiEditBoxFill
              style={{
                backgroundColor: "#3080ED",
                padding: 5,
                borderRadius: 5,
                color: "white",
                marginRight: 15,
              }}
              size={30}
            />
          </i>}
        </>

        <>
         <i
            style={{ position: "relative", top: 3, cursor: "pointer" }}
            onClick={() => {
              // setSelectedModal("Case")
              // setSelectedCase(record.name);
              // console.log(record.name)
              setCurrentActiveId(record.name);
              setShowConfirmModal(true);
            }}
          >
            <BsFillTrashFill
              style={{
                backgroundColor: "#FF0000",
                padding: 5,
                borderRadius: 5,
                color: "white",
              }}
              size={26}
            />
          </i>
        </>
      </td>
    ),
  },

  // {
  //   label: "Category",
  //   name: "name",
  // },
  // {
  //   label: "Label",
  //   name: "name",
  // },
  // {
  //   label: "Case Code",
  //   name: "name",
  // },
  // {
  //   label: "Resolved",
  //   name: "name",
  // },
  // {
  //   label: "Assigned",
  //   name: "name",
  // },
  // {
  //   label:"Created At",
  //   name:"name"
  // },{
  //   label: "Action",
  //   name: "name"
  // }
];

  useEffect(() => {
    fetchData();
    // getAllCases().then((res:  any) => {
    //   console.log('RESPONSE FROM API: ', res);
    // })
  }, []);

  const [itemToBeEdited,  setItemToBeEdited] = useState(null);

  const handleItemEdited = () => {
    // Show Toast
  }

  const toggleEditModal = () => {
    setShowEditModal(!showEditModal);
  }

  const deleteCase = async(caseId: any) => {

    // LOGIC TO CASE SPECIALITY
    const docRef = doc(collection(db,"Cases"),caseId)
    setShowConfirmModal(false);
    if(caseId != null) {
        await deleteDoc(docRef).then(() => {
          fetchData();
          setShowConfirmModal(false);
        })
    }
  }


  return (
    <>
    <Layout title="case" pageTitle="cases">
      <div className="section">
        <div className="parent-con">
          <div className="data-table">
            <div className="top">
              <div className="span">
                <h3>All Cases</h3>
              </div>

              <button
              onClick={toggleAddModal}
              className="btn btn-primary btn-add student-button">
                New Case
              </button>
            </div>
            <div className="table-con">
              <div style={{ textAlign: "center" }}>
                <BeatLoader
                  color="#3080ED"
                  loading={loading}
                  cssOverride={override}
                />
              </div>
              <Search
                  placeholder="Search for data..."
                  onSearch={handleSearch}
                  onChange={(e) => handleSearch(e.target.value)}
                  value={searchText}
                  style={{ width: 200, marginBottom: 16, marginRight: 10 }}
                />

                {/* <Search
                  placeholder="Patient's Phone"
                  onSearch={handleSearchPatietsPhone}
                  onChange={(e) => {
                    setPatientSearchPhone(e.target.value);
                    clearPatientSearch(e.target.value);
                  }}

                  value={patientSearchPhone}
                  style={{ width: 200, marginBottom: 16 }}
                /> */}
              <Table
                  dataSource={filteredData.map((item, index) => ({ ...item, index: index + 1 }))}
                  columns={rows}
                  onChange={handleChange}
                  rowKey="name"
                  showSorterTooltip={false}
                  pagination={{ pageSize: 10 }}
                />
              {/* <table>
                <thead>
                  <tr>
                    {rows.map((row: any, index: any) => (
                      <th key={index} className={row.name}>
                        {row.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {caseData?.map((data: any, index: any) => (
                    <tr key={data.name}>
                      <td>{data.category}</td>
                      <td>{data.label}</td>
                      <td>{data.name}</td>
                      <td>{data.is_case_resolved?"Resolved":"Unresolved"}</td>
                      <td>{`${data?.doctor_uid? "True": "False"}`}</td>
                      <td style={{fontFamily:"Arial, Helvetica, sans-serif"}}>{formatTimeStamp(`${data.createdAt}`,data.createdAt)}</td>
                      <td className="flex-start">
                          <i
                            style={{ position: "relative", top: 3 }}
                            onClick={() => {
                              // setSelectedModal("Slide")
                              // setSelectedCase(data.name);
                              toggleAddModal();
                            }}
                          >
                            <BsPersonFillAdd style={{backgroundColor:"#07575b", padding:5, borderRadius:5, color:"white",marginRight:15}} size={30} />

                          </i>

                          <i
                            style={{ position: "relative", top: 3 }}
                            onClick={() => {
                              // setSelectedModal("Case")
                              // setSelectedCase(data.name);
                              toggleAddModal();
                            }}
                          >
                            <FiFolderPlus  style={{backgroundColor:"#07575b", padding:5, borderRadius:5, color:"white"}} size = {30} />
                          </i>
                      </td>
                    </tr>
                  ))
                  }
                </tbody>
              </table> */}
            </div>
          </div>
        </div>
      </div>

    </Layout>

    {showConfirmodal && (
          <ConfirmModal 
              title="Are you sure you want to delete case ?"
              onAccept={() => deleteCase(currentActiveId)}
              onCancel={() => setShowConfirmModal(false)}
          />
      )}

    {showCreateModal && (
        <CreateCaseModal
          onContentAdded={handleContentAdded}
          onClose={() => {
            setShowCreateModal(false)
            fetchData()
          }}
        />
      )}

      {
        showEditModal && (
          <EditCaseModal 
            onClose={toggleEditModal}
            item={itemToBeEdited}
            onUpdateDone={() => {
              setShowEditModal(false);
              fetchData();
            }}
          />
        )
      }

      {
        showAssignedModal && (
              <SelectUserModal
              onContentAdded={handleContentAdded}
              onClose={toggleAssignedSlideModal}
              selectedCase={selectedCase}
              speciaList={docs}
              caseType={selectedCaseCategory}
              caseData={selectedCaseData}
        />
        )
      }

      {
        showPatientDetailsModal &&(
          <PatientDetailsModal 
          onCancel={() => {
            setShowPatientDetailsModal(false);
            setPatientId(null);
          }}
          userId={patientId}
          />
          
        )
      }

      {
        showUnassignUserModal &&  <UnassignCaseModal 
          onContentAdded={handleContentAdded}
          onClose={toggleUnAssignSlideModal}
          selectedCase={selectedCase}
          speciaList={docs}
          caseType={selectedCaseCategory}
          caseData={selectedCaseData}
        />
      }


    </>
  );
}

export default Index;
